import { AntDesign, MaterialCommunityIcons, MaterialIcons } from "@expo/vector-icons";
import { Box, Button, Center } from "native-base";
import React from "react";

import FormButton from "@/components/atoms/FormButton";
import HeaderAddressButton from "@/components/molecules/HeaderAddressButton";
import MobileHeader from "@/components/molecules/MobileHeader";
import Container from "@/components/organisms/Container";

import CheckoutResume from "../../components/molecules/CheckoutResume";
import StepCard from "./components/StepCard";
import { formatPaymentTypeName, getDeliveryDateDescription } from "./functions";
import { CheckoutScreenProps, ModalTypesEnum } from "./types";

const CheckoutMobile = ({
  isLoading,
  isDisabled,
  store,
  items,
  total,
  serviceTaxValue,
  subtotal,
  shipmentValue,
  clientDocument,
  fallbackContact,
  paymentMethod,
  deliveryTime,
  voucherDetails,
  onOpenModal,
  onFinishCheckout,
  onPressBack,
}: CheckoutScreenProps) => {
  return (
    <Container px="2" Header={<MobileHeader title="Checkout" onBackPress={onPressBack} />}>
      <Box w="full" bgColor="white.50" shadow="4" my="4" p="2" rounded="md">
        <HeaderAddressButton w="100%" showCompletion />
      </Box>
      <CheckoutResume
        store={store}
        itemsQuantity={items.length}
        shipmentValue={shipmentValue}
        subtotal={subtotal}
        total={total}
        voucherDetails={voucherDetails}
        serviceTaxValue={serviceTaxValue}
      />
      <StepCard
        title="Entrega"
        description={getDeliveryDateDescription(deliveryTime)}
        icon={<MaterialIcons name="delivery-dining" />}
        buttonTitle="Escolher horário"
        hasError={!deliveryTime}
        onChange={() => onOpenModal(ModalTypesEnum.SCHEDULE)}
      />
      <StepCard
        title="Método de pagamento"
        description={
          paymentMethod &&
          `${formatPaymentTypeName(paymentMethod.type)} - ${paymentMethod.description}`
        }
        icon={<MaterialIcons name="attach-money" />}
        buttonTitle="Escolher método"
        hasError={!paymentMethod}
        onChange={() => onOpenModal(ModalTypesEnum.PAYMENT_METHOD)}
      />
      <StepCard
        title="Cupom de desconto"
        description={voucherDetails?.cupom?.codigo}
        icon={<MaterialCommunityIcons name="cash-minus" />}
        buttonTitle="Adicionar cupom"
        hasError={false}
        onChange={() => onOpenModal(ModalTypesEnum.VOUCHER)}
      />
      <StepCard
        title="Faturamento"
        description={clientDocument && `${clientDocument}`}
        icon={<AntDesign name="idcard" />}
        buttonTitle="Adicionar CPF/CNPJ"
        hasError={false}
        onChange={() => onOpenModal(ModalTypesEnum.CLIENT_DOC)}
      />
      <StepCard
        title="Contato reserva"
        description={fallbackContact && `${fallbackContact.name} - ${fallbackContact.phone}`}
        icon={<MaterialCommunityIcons name="whatsapp" />}
        buttonTitle="Adicionar contato"
        hasError={!fallbackContact}
        onChange={() => onOpenModal(ModalTypesEnum.CONTACT)}
      />
      <Box my="8">
        <FormButton isLoading={isLoading} isDisabled={isDisabled} onPress={onFinishCheckout}>
          Finalizar compra
        </FormButton>
      </Box>
      <Center mb="8">
        <Button variant="ghost" onPress={onPressBack}>
          Cancelar
        </Button>
      </Center>
    </Container>
  );
};

export default CheckoutMobile;
